import React from 'react';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import './logos.scss';

import image1 from '../../images/logos/logo-1.png';
import image2 from '../../images/logos/logo-2.png';
import image3 from '../../images/logos/logo-3.png';
import image4 from '../../images/logos/logo-4.png';
import image5 from '../../images/logos/logo-5.png';
import image6 from '../../images/logos/logo-6.png';
import image7 from '../../images/logos/logo-7.png';
import image8 from '../../images/logos/logo-8.png';
import image9 from '../../images/logos/logo-9.png';
import image10 from '../../images/logos/logo-10.png';
import image11 from '../../images/logos/logo-11.png';
import image12 from '../../images/logos/logo-12.png';
import image13 from '../../images/logos/logo-13.png';

import image14 from '../../images/logos/logo-14.png';
import image15 from '../../images/logos/logo-15.png';
import image16 from '../../images/logos/logo-16.png';
import image17 from '../../images/logos/logo-17.png';
import image18 from '../../images/logos/logo-18.png';
import image19 from '../../images/logos/logo-19.png';
import image20 from '../../images/logos/logo-20.png';
import image21 from '../../images/logos/logo-21.png';
import image22 from '../../images/logos/logo-22.png';
import { Container } from '@mui/material';

const Logos = () => <Container
    maxWidth='lg'
    className='logos'
>
    <div className="container">
        <div className="section page-title pb-5">
        </div>
        <div className="terms-content-container">
            <h3><b>Privaposts Logos</b></h3>
            <div className="priv-content">
                <p>Privaposts retains full Trademark and Copyright ownership over the following logos and their variations:</p>
                <ol>
                    <li>Butterfly logo with the keyhole</li>
                    <li>Box with the keyhole</li>
                    <li>The word 'Privaposts' in custom font</li>
                </ol>
                <p>Save these logos and use them to market your Privaposts profile. These logos have transparent backgrounds so you can copy and paste them onto any image and create any custom background you like 🙂</p>

                <p>We've also made some Privaposts Instagram highlight icons free. These Instagram highlights cover photos can be saved and used anywhere you like. You can also use these Instagram covers as profile photos or post them on other social media sites such as twitter, Facebook, Snapchat, Youtube etc.</p>
                <h4><b>Balance the Privaposts Brand with your brand</b></h4>
                <p>Avoid representing the Privaposts brand in a way that:</p>
                <ul>
                    <li>Makes the Instagram brand the most distinctive or prominent feature.</li>
                    <li>Implies partnership, sponsorship or endorsement.</li>
                    <li>Puts the brand in a negative context as part of a script or storyline. You must comply with our <Link to="/terms">Terms of Use</Link> and <Link to="/privacy-policy">Privacy.</Link></li>
                </ul>
                <h4><b>Keep the word Instagram consistent</b></h4>
                <ul>
                    <li>Keep the letter “P” in Privaposts capitalized and in same font size and style as the content surrounding it.</li>
                    <li>Don’t modify, abbreviate or translate the word Privaposts to a different language or by using non-English characters, or use any of our logos to replace it.</li>
                    <li>Don’t combine “Priva” or “posts” with your own brand.</li>
                </ul>
                <h4 className="text-center"><b>Privaposts Logos with Transparent Backgrounds</b></h4>
                <p className="text-center">(To be used when making custom logos or adding to marketing material)</p>
                <p><b>Please go to this link to access and save these logos:</b> <a href="https://priva.uvdesk.com/en//articles/360021298173-Privaposts-Logo-Instagram-Highlights-covers" target="_blank">https://priva.uvdesk.com/en//articles/360021298173-Privaposts-Logo-Instagram-Highlights-covers</a></p>
                <div className="priva-logo-trans-bg">
                    <p className="text-center"><LazyLoadImage src={image1} /></p>
                    <p className="text-center"><LazyLoadImage src={image2} /></p>
                    <p className="text-center"><LazyLoadImage src={image3} /></p>
                    <p className="text-center"><LazyLoadImage src={image4} /></p>
                    <p className="text-center"><LazyLoadImage src={image5} /></p>
                    <p className="text-center"><LazyLoadImage src={image6} /></p>
                    <p className="text-center"><LazyLoadImage className="big" src={image7} /></p>
                    <p className="text-center"><LazyLoadImage className="big" src={image8} /></p>
                    <p className="text-center"><LazyLoadImage className="big" src={image9} /></p>
                    <p className="text-center"><LazyLoadImage className="big" src={image10} /></p>
                    <p className="text-center"><LazyLoadImage className="big" src={image11} /></p>
                    <p className="text-center"><LazyLoadImage className="big" src={image12} /></p>
                    <p className="text-center">
                        <LazyLoadImage src={image13} />
                        Privaposts Gradient Circle
                    </p>
                </div>
                <h4 className="text-center"><b>Privaposts Logos for Censoring Content</b></h4>
                <p><b>How to save logos:</b></p>
                <p><b>Please go to this link to access and save these logos:</b> <a href="https://priva.uvdesk.com/en//articles/360021298173-Privaposts-Logo-Instagram-Highlights-covers" target="_blank">https://priva.uvdesk.com/en//articles/360021298173-Privaposts-Logo-Instagram-Highlights-covers</a></p>
                <p>
                    <b>Desktop:</b>
                    {' '}
                    Drag and drop into folder
                </p>
                <p>
                    <b>Mobile:</b>
                    {' '}
                    Press and hold finger on image to bring up the save / copy menu, then save 🙂
                </p>
                <div className="priva-logo-censoring-container">
                    <LazyLoadImage src={image14} />
                    <LazyLoadImage src={image15} />
                    <LazyLoadImage src={image16} />
                    <LazyLoadImage src={image17} />
                    <LazyLoadImage src={image18} />
                    <LazyLoadImage src={image19} />
                    <LazyLoadImage src={image20} />
                    <LazyLoadImage src={image21} />
                    <LazyLoadImage src={image22} />
                </div>
                <p><small>Privaposts' trademarks, including Privaposts, the Privaposts logo, the Privaposts butterfly logo, The Privaposts gradient circle, the Privaposts glyph and app logos, are all owned by Privaposts and may only be used as provided in these guidelines or with Privaposts' permission. You may not use or register, or otherwise claim rights in any Privaposts trademark, including as or as part of any trademark, service mark, company name, trade name, username or domain registration.</small></p>

                <p><small>You should not use or claim rights to 'Priva' or 'Posts' in a way that is confusingly similar to or dilutive of Privaposts, including as, or as any part of, a trademark. Do not use Privaposts' trademarks for anything that would be inconsistent with <Link to="/terms">Terms of Use</Link> or <Link to="/privacy-policy">Privacy.</Link> We may revoke permission to use Privaposts' trademarks at any time. Privaposts reserves the right to withhold approval of content if it's inconsistent with the Privaposts brand.</small></p>

            </div>
        </div>
    </div>
</Container>;

export default Logos;
